/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:84377f21-560e-4b4a-adce-115f859a21fb",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_bYQTqHNHr",
    "aws_user_pools_web_client_id": "2arlkralufqrqlbb693tq78n15",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "survey080604f0817048968acc0642c399fbec144211-develop",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
